import { render } from "./Checkout-Shipping.vue?vue&type=template&id=4901811c"
import script from "./Checkout-Shipping.vue?vue&type=script&lang=js"
export * from "./Checkout-Shipping.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Giant\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__